"use strict";import{HelpText as e}from"./src/HelpText.js";import{defineElement as t}from"@spectrum-web-components/base/src/define-element.js";t("sp-help-text",e);
//# sourceMappingURL=sp-help-text.js.map
